import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import {
    PdfBackgroundsResponse,
    PdfBackgroundType,
} from '@/models/pdfBackground';

const baseUrl = () => urlBuilder('order', 'pdfbackgrounds');

const buildScopeQuery = (params: {
    userId?: string | null;
    shortProductId?: string | null;
    language?: string;
}): string => {
    const search = new URLSearchParams();
    if (params.userId) search.set('userId', params.userId);
    if (params.shortProductId)
        search.set('shortProductId', params.shortProductId);
    if (params.language) search.set('language', params.language);
    const query = search.toString();
    return query ? `?${query}` : '';
};

export const pdfBackgroundUrl = (
    type: PdfBackgroundType,
    params: { userId?: string | null; shortProductId?: string | null } = {}
): string => `${baseUrl()}/${type}${buildScopeQuery(params)}`;

export const pdfBackgroundPreviewUrl = (
    type: PdfBackgroundType,
    params: {
        userId?: string | null;
        shortProductId?: string | null;
        language?: string;
    } = {}
): string => `${baseUrl()}/${type}/preview${buildScopeQuery(params)}`;

export const pdfBackgroundDesignTemplateUrl = (
    type: PdfBackgroundType,
    language?: string
): string =>
    `${baseUrl()}/${type}/design-template${buildScopeQuery({ language })}`;

export const pdfBackgroundApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['PDF_BACKGROUND'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getPdfBackgrounds: builder.query<PdfBackgroundsResponse, void>({
                query: () => baseUrl(),
                providesTags: ['PDF_BACKGROUND'],
            }),
        }),
    });

export const { useGetPdfBackgroundsQuery } = pdfBackgroundApi;

export const PDF_BACKGROUND_CACHE_TAG = 'PDF_BACKGROUND' as const;
